import { createSelector } from 'reselect';

import { ASAP_TIME } from '../constants';

export default createSelector([], () => ({
  PickupTime: ASAP_TIME,
}));
